import React, {useState} from "react";
import {withNamespaces} from "react-i18next";
import StompClient from "react-stomp-client";

const WidgetSensors = ({t}) => {

    const [sensors, setSensors] = useState([])

    const handleMessage = (stompMessage) => {
        const messageBody = JSON.parse(stompMessage.body);
        const findSensors = sensors.find((x) => x.id === messageBody.id);
        if(findSensors) {
            const objIndex = sensors.findIndex((x) => x.id === messageBody.id);
            sensors[objIndex].value = messageBody.value;
            setSensors(sensors);
        }
        else {
            setSensors([...sensors, messageBody]);
        }
    }

    return (
        <div>

            <StompClient
                endpoint={`ws://${window.location.hostname}:15674/ws`}
                topic={ "exchange/amq.topic/sensors.#" }
                onMessage={handleMessage}
            >
                <div className="card ">
                    <div className="card-header">
                        <div className="card-title d-flex w-100">
                            <b className="align-self-center">Ujeżdzalnia piwnica</b>
                            <div className="ml-auto d-flex">
                                { sensors.map((item, idx) => {
                                    return (
                                        <span className="mx-2" key={idx}><b>{ t(item.type) } </b> : { item.value} { item.unit}  </span>
                                    )
                                }) }
                            </div>
                        </div>
                    </div>
                </div>
            </StompClient>
        </div>
    )
}
export default withNamespaces()(WidgetSensors);
